import { render } from "./GreaterThanIcon.vue?vue&type=template&id=22bdce5e"
import script from "./GreaterThanIcon.vue?vue&type=script&lang=js"
export * from "./GreaterThanIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__